<template>
  <div>
    <h3 class="popover-title">
      {{ isBlocked ? $t('BULK_BLOCKED_SEARCH_MODAL_TITLE_BLOCKED', {number: searchedNumber}) : $t('BULK_BLOCKED_SEARCH_MODAL_TITLE_NOT_BLOCKED', {number: searchedNumber}) }}
      <a
        class="close"
        @click.prevent="closeModal"
      >
        <i
          class="typcn typcn-delete"
          aria-hidden="true"
        />
      </a>
    </h3>
    <div
      v-if="searchStatus.status !== 'pending'"
      class="text-justify p-15"
    >
      <div
        v-if="!isBlocked"
        class="p-t-10"
      >
        <p class="m-b-20 m-t-5">
          <i class="fa fa-times text-danger" />
          {{ $t('BULK_BLOCKED_NUMBER_SEARCH_RESULT_NOT_FOUND', {number: searchedNumber}) }}
        </p>
        <p
          v-t="'BLOCK_NUMBER_EXPLANATION'"
          class="text-muted"
        />
      </div>
      <div v-if="searchResult && searchResult.blockedInAccount">
        <p>
          <i class="fa fa-check text-success" />
          {{ $t('BULK_BLOCKED_NUMBER_SEARCH_RESULT_ACCOUNT_LEVEL', {number: searchedNumber}) }}
        </p>
      </div>
      <div v-if="searchResult && !searchResult.blockedInAccount && searchResult.campaigns && searchResult.campaigns.length > 0">
        <p class="m-b-10">        
          <i class="fa fa-check text-success" /> 
          {{ $t('BULK_BLOCKED_NUMBER_SEARCH_RESULT_CAMPAIGN_LEVEL', {number: searchedNumber}) }}
        </p>
        <div class="well well-sm m-t-10 m-b-0">
          <div class="form-horizontal">
            <div
              class="row"
            >
              <div class="col-md-8">
                <ul
                  class="list-unstyled form-control-static list-text-overflow"
                >
                  <li
                    v-for="campaignId in searchResult.campaigns"
                    :key="campaignId"
                  >
                    <a
                      rel="noopener"
                      target="_blank"
                      href="javascript:;"
                      class="table-ellipsis__name linked-name"
                      @click.prevent="gotToCampaign(campaignId)"
                    >
                      <span
                        class="display-text"
                        :title="campaignName(campaignId)"
                      >
                        {{ campaignName(campaignId) }}
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="searchStatus.status == 'pending'"
      class="p-15 text-center"
    >
      <Loader />
      <span v-t="'BULK_SEARCH_LOADING'" />
    </div>
    <div
      v-if="deleteButtonEnabled"
      slot="footer"
      class="text-right p-10"
    >
      <button
        v-t="'UNBLOCK_NUMBER'"
        type="button"
        class="btn btn-primary"
        @click="unblockNumber()"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import messages from '../../locales';
import Loader from '@/core/components/Loader';
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { getStatus } from '@/store/helpers';

export default {
  components: {
    Loader,
  },
  props: {
    showModal: {
      type: Boolean,
      default() {
        return false;
      },
    },
    searchedNumber: {
      type: String,
      default() {
        return '';
      },
    },
    campaignsMap: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data: function () {
    return {
      open: this.showModal,
    };
  },
  computed: {
    ...mapState('blockedNumbers', ['searchResult']),
    ...mapState('blockedNumbers', {
      searchStatus: (state) => getStatus(state, 'SEARCH_BULK_BLOCKED_NUMBER') || {},
    }),
    deleteButtonEnabled() {
      return (
        this.searchBulkBlockedNumberStatus !== 'pending' &&
        this.searchResult &&
        ( this.searchResult.blockedInAccount || this.searchResult.campaigns)
      );
    },
    isBlocked() {
      return this.searchResult && ( this.searchResult.blockedInAccount || this.searchResult.campaigns);
    }
  },
  watch: {
    showModal: function (newVal) {
      // watch it
      this.open = newVal;
    },
  },
  methods: {
    campaignName(id) {
      return this.campaignsMap[id] ? this.campaignsMap[id].name : 'Not found';
    },
    closeModal() {
      this.$emit('hide-modal');
    },
    unblockNumber() {
      this.$emit('unblock-number');
    },
    gotToCampaign(id) {
      $ngStateService.go('dashboard.campaign', {
        campaignId: id
      });
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>